<template>
<div>
    <div class="container-fluid">
        <div class="row mt-1">
            <div class="col-md-4">
                <div class="print_logo " style="display:none;margin-top: -40px;" slot="header">
                    <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
                </div>
            </div>
            <div class="col-md-4 mt-6">
                <h5 class="text-blue print_logo" style="display:none;margin-top: 20px;">
                    Training Analysis Report
                </h5>
            </div>
            <div class="col-md-4" style="margin-top:-50px">
                <h6 class="print_logo mt-1" style="text-align:justify; display:none; padding-left: 45px">
                    Country Office Pakistan<br />Monitoring & Evaluation Unit
                </h6>
            </div>
            <div class="col-md-12 print_logo" style="display:none;">
                <h6 class="print_logo print-tr-title" style="display:none; margin-bottom:-7px;">
                    Event Title
                </h6>
                <br />
                <h6 class="text-blue print-trainin-title" style="">
                    {{ trainingDetails.title }}
                </h6>
            </div>
        </div>

        <h4 class="text-blue  print-training-title">
            {{ trainingDetails.title }}
        </h4>

        <div class="row">
            <div class="col-lg-12">
                <h6 class="text-blue print-title">Event Brief Information</h6>
            </div>
            <div class="col-lg-12">
                <button v-if="this.permission == 'admin' || this.permission =='program_officer'" class="btn btn-primary print-media float-right ml-3" @click="PrintTrainingDetails">
                    <i class="fas fa-print"></i> Print Report
                </button>
                <button v-if="this.permission == 'admin'" class="btn btn-primary text-uppercase btn-report float-right ml-3" @click="openWindow1">
                    Custom Print
                </button>
                <button class="btn btn-primary text-uppercase btn-report float-right ml-3" @click="goToPrintEvent">
                    Print Event Details
                </button>
                <button class="btn btn-primary text-uppercase btn-report float-right" @click="openIndividual">Individual Analysis</button>

            </div>
        </div>

        <div class="row p-lg-3">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <template v-if="trainingDetails && trainingDetails.district">
                            <th scope="col">Country</th>
                            <td>
                                {{ (trainingDetails.district.province.country.title) || 'N/A' }}
                            </td>
                            <th scope="col">Province</th>
                            <td>
                                {{ (trainingDetails.district.province.title) || 'N/A' }}
                            </td>
                            <th scope="col">City</th>
                            <td>
                                {{ trainingDetails.district.title || 'N/A' }}
                            </td>
                        </template>
                        <template v-else>
                            <th scope="col">Country</th>
                            <td>No country added</td>
                            <th scope="col">Province</th>
                            <td>No province added</td>
                            <th scope="col">City</th>
                            <td>No City added</td>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Advisor</th>
                        <td>{{ trainingDetails.advisor.name || 'N/A' }}</td>
                        <th scope="row">Program Officer</th>
                        <td>{{ trainingDetails.programofficer.name || 'N/A' }}</td>
                        <th scope="row">Donor</th>
                        <td>
                            <template v-for="(doner) in doners">
                                {{ doner.title }}
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Start Date</th>
                        <td>{{ formatDate4(trainingDetails.startdate)}}</td>
                        <th scope="row">End Date</th>
                        <td>{{ formatDate4(trainingDetails.enddate)}}</td>

                        <th scope="row">No. of Days</th>
                        <td>{{ trainingDetails.noofdays || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <th scope="row">Sub Programme/Project</th>
                        <td colspan="5">{{ trainingDetails.subprogram.title || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <th scope="row">Facilitators</th>
                        <td colspan="5">
                            <template v-for="(trainer) in alltrainers">
                                {{ trainer.trainer.name }} ,</template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <h6 class="text-blue print_logo" style="display:none;margin-top:-15px; font-size: 15px;">
            Detailed Overall Training Analysis
        </h6>

        <div class="row p-lg-3">
            <!-- --------------------------  -->
            <div class="col-lg-4 col-md-4" style="padding-left:0.5px">
                <table class="table table-bordered mb-1">
                    <thead>
                        <tr>
                            <th style="text-align:center">Gender Segregation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="text-align:center">
                                <div id="pie-male-female" style="min-height:170px;height: 170px; width: 100%;margin-bottom:0px"></div>
                                <b>Male: </b>{{ maleCount }} <b>Female: </b>{{ femaleCount }}
                                <b>Other: </b>{{ otherCount }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- --------------------------  -->
            <div class="col-lg-4 col-md-4" style="padding-left:0px;padding-right: 0px;">
                <table class="table table-bordered mb-1">
                    <thead>
                        <tr>
                            <th>Departments</th>
                            <th>No</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(depart, dida) in departmentReport.Dreport" :key="dida">
                            <td style="padding:0rem 0.75rem">{{ depart.title }}</td>
                            <td style="padding:0rem 0.75rem">{{ depart.count }}</td>
                        </tr>

                        <tr>
                            <td style="padding:0rem 0.75rem">Other</td>
                            <td style="padding:0rem 0.75rem">
                                {{ departmentReport.other }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- --------------------------  -->
            <div class="col-lg-4 col-md-4" style=" padding-left:0px">
                <table class="table table-bordered mb-1">
                    <thead>
                        <tr>
                            <th>Participants Designation</th>
                            <th>No</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(desig, kajds) in designationReport.DesignationReport" :key="kajds">
                            <td style="padding:0rem 0.75rem">{{ desig.title }}</td>
                            <td style="padding:0rem 0.75rem">{{ desig.count }}</td>
                        </tr>
                        <tr>
                            <td style="padding:0rem 0.75rem">Other</td>
                            <td style="padding:0rem 0.75rem">
                                {{ designationReport.other }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- --------------------------  -->
        <div class="row p-lg-3">
            <div class="col-lg-3 col-md-3 line-bordered text-center print_screen2">
                <h6 class="mt-3 text-dark" style="">
                    Average Actual knowledge change
                </h6>
                <div id="average-actual-knowledge-change" style="height: 300px; width: 100%;" class="print-actual-graph"></div>
                <b v-if="this.postPercent != 0 && this.prePercent != 0">
                    Knowledge Gain =
                    {{ (((this.postPercent - this.prePercent) / this.prePercent) * 100).toFixed(2) + '%' }}
                </b>
            </div>
            <div class="col-lg-3 col-md-3 line-bordered text-center" v-for="(question, qindex) in questionsArray" :key="qindex">
                <h6 class="mt-3 text-dark">{{ question.questionTitle }}</h6>

                <!-- Dynamic Chart Container -->
                <div :id="'graph' + qindex" style="height: 300px; width: 100%"></div>
            </div>

            <div class="col-lg-3 col-md-3 line-bordered text-center" v-for="(question, qindex) in questionsPArray" :key="qindex">
                <h6 class="mt-3 text-dark">{{ question.questionTitle }}</h6>

                <!-- Dynamic Chart Container -->
                <div :id="'graphp' + qindex" style="height: 300px; width: 100%"></div>
            </div>
        </div>
    </div>

    <footer id="pageFooter" style="float-right">
        <!-- <div style="float-right">Copyright Protected © 2021</div> -->
    </footer>
</div>
</template>

<script>
import axios from "axios";
import Highcharts from "../../../public/highcharts";
import {
    formatDate4
} from "../../utils/DateFormate"

export default {
    data: () => ({
        trainingDetails: [],
        alltrainers: [],
        doners: [],
        trainingCode: "",
        maleCount: 0,
        femaleCount: 0,
        otherCount: 0,
        totalCount: 0,
        trainingID: "",
        checkBox1: false,
        basepath: process.env.VUE_APP_BASE_PATH,
        questions: [],
        departmentReport: [],
        designationReport: [],
        labelArray: [],
        labelPArray: [],
        selectedOptions: [],
        selectedPOptions: [],
        questionsArray: [],
        questionsPArray: [],
        counterSelectedOptions: 0,
        counterA: 0,
        prePercent: 0,
        postPercent: 0,
        permission: localStorage.getItem("isPermission"),
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$gloabal.toastError('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$gloabal.toastError(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                if (response.data && response.data.training) {
                    this.trainingDetails = response.data.training;
                    this.trainingID = response.data.training.id;
                    this.showTrainers(response.data.training.id);
                    this.showMaleFemale(response.data.training.id);
                    this.DepartmentData(response.data.training.id);
                    this.DesignationData(response.data.training.id);
                    this.allStandardQuestions(response.data.training.id);
                    this.actualKnowledgechange(response.data.training.id);
                    this.allStandardPostQuestions(response.data.training.id);

                    if (response.data && response.data.doner) {
                        this.doners = response.data.doner;
                    }
                    //this.showTrainees(response.data.training.id);
                }
            });

    },

    methods: {
        formatDate4,
        actualKnowledgechange: function actualKnowledgechange(tId) {

            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/actual/knowledge-change/get/" +
                    tId
                )
                .then(async response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response) {

                        this.prePercent = await Math.round(response.data.prePercentage);
                        this.postPercent = await Math.round(response.data.postPercentage);
                        Highcharts.chart("average-actual-knowledge-change", {
                            chart: {
                                type: "column",
                                height: '100%',
                                reflow: true,
                                spacing: [10, 10, 15, 10]
                            },
                            title: {
                                text: "Browser market shares. January, 2018",
                            },

                            accessibility: {
                                announceNewData: {
                                    enabled: true,
                                },
                            },
                            xAxis: {
                                type: "category",
                            },
                            yAxis: {},
                            legend: {
                                enabled: false,
                            },
                            plotOptions: {
                                series: {
                                    borderWidth: 0,
                                    dataLabels: {
                                        enabled: true,
                                        format: "{point.y}%",

                                    }
                                },
                            },

                            tooltip: {
                                // headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}%</b> of total<br/>',
                            },

                            series: [{
                                // name: "",
                                colorByPoint: true,
                                data: [{
                                        name: "Pre",
                                        y: response.data.prePercentage,
                                        color: "#80ff80"
                                    },
                                    {
                                        name: "Post",
                                        y: response.data.postPercentage,
                                        color: "#63b94b",
                                    },
                                ],
                            }, ],
                            responsive: {
                                rules: [{
                                    condition: {
                                        maxWidth: 500
                                    },
                                    chartOptions: {
                                        legend: {
                                            itemStyle: {
                                                fontSize: '10px'
                                            }
                                        }
                                    }
                                }]
                            }
                        });
                    }
                });
        },
        allStandardQuestions: function allStandardQuestions(tId) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/standardQuestionsNew/all/get/" +
                    tId
                )
                .then(response => {
                    if (
                        response.data
                    ) {
                        setTimeout(() => {
                            response.data.forEach((element, index) => {

                                if (element.label.length == 2) {

                                    Highcharts.chart("graph" + index, {
                                        chart: {
                                            plotBackgroundColor: null,
                                            plotBorderWidth: null,
                                            plotShadow: false,
                                            type: "pie",

                                        },
                                        title: {
                                            text: "Browser market shares in January, 2018",
                                        },
                                        tooltip: {
                                            pointFormat: "{series.name}: <b>{point.percentage:.2f}%</b>",
                                        },
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                cursor: "pointer",
                                                // colors: pieColors,
                                                dataLabels: {
                                                    enabled: true,
                                                    format: "<b>{point.name}</b><br>{point.percentage:.0f} %",
                                                    distance: -35,
                                                    filter: {
                                                        property: "percentage",
                                                        operator: ">",
                                                        value: 4,
                                                    },
                                                },
                                            },
                                        },

                                        series: [{
                                            name: "Answer",
                                            colorByPoint: true,
                                            data: [{
                                                    name: element.label[0],
                                                    y: element.Options[0],
                                                    color: "#71da71",
                                                },
                                                {
                                                    name: element.label[1],
                                                    y: element.Options[1],
                                                    color: "#ff5c33",
                                                },
                                            ],
                                        }, ],
                                    });
                                } else if (
                                    element.label &&
                                    element.label.length == 4
                                ) {

                                    Highcharts.chart("graph" + index, {
                                        chart: {
                                            type: "column",
                                        },
                                        title: {
                                            text: "Stacked column chart",
                                        },
                                        xAxis: {
                                            // categories: ["Practicals Testing"],
                                        },
                                        yAxis: {
                                            min: 0,
                                            stackLabels: {
                                                enabled: false,
                                                style: {
                                                    fontWeight: "bold",
                                                    color:
                                                        // theme
                                                        (Highcharts.defaultOptions.title.style &&
                                                            Highcharts.defaultOptions.title.style
                                                            .color) ||
                                                        "gray",
                                                },
                                            },

                                        },
                                        legend: {
                                            align: "center",
                                            x: -30,
                                            verticalAlign: "bottom",
                                            y: 15,
                                            floating: false,
                                            backgroundColor: Highcharts.defaultOptions.legend
                                                .backgroundColor || "white",
                                            borderColor: "#CCC",
                                            borderWidth: 1,
                                            shadow: false,
                                            itemStyle: {
                                                fontSize: '10px',
                                            }
                                        },
                                        tooltip: {
                                            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                            shared: true,
                                        },
                                        plotOptions: {
                                            column: {
                                                stacking: "percent",
                                                dataLabels: {
                                                    enabled: true,
                                                    formatter: function () {
                                                        if (this.y != 0) {
                                                            return this.point.percentage.toFixed(1) + '%'
                                                        }
                                                    },
                                                    // enabled:true,
                                                    // format:'{point.percentage:.2f} %',
                                                }
                                            },
                                        },
                                        series: [{
                                                name: element.label[0],
                                                data: [element.Options[0]],
                                                color: "#D1324E"

                                            },
                                            {
                                                name: element.label[1],
                                                data: [element.Options[1]],
                                                color: "#EF522F"

                                            },
                                            {
                                                name: element.label[2],
                                                data: [element.Options[2]],
                                                color: "#FEC447"
                                            },
                                            {
                                                name: element.label[3],
                                                data: [element.Options[3]],
                                                color: "#6AAA4A",

                                            }

                                        ]
                                    });

                                } else if (
                                    element.label &&
                                    element.label.length == 3
                                ) {

                                    Highcharts.chart("graph" + index, {
                                        chart: {
                                            type: "column",
                                        },
                                        title: {
                                            text: "Stacked column chart",
                                        },
                                        xAxis: {
                                            // categories: ["Testing"],
                                        },
                                        yAxis: {
                                            min: 0,
                                            stackLabels: {
                                                enabled: false,
                                                style: {
                                                    fontWeight: "bold",
                                                    color:
                                                        // theme
                                                        (Highcharts.defaultOptions.title.style &&
                                                            Highcharts.defaultOptions.title.style
                                                            .color) ||
                                                        "gray",
                                                },
                                            },
                                        },
                                        legend: {
                                            align: "right",
                                            x: -30,
                                            verticalAlign: "bottom",
                                            y: 15,
                                            floating: false,
                                            backgroundColor: Highcharts.defaultOptions.legend
                                                .backgroundColor || "white",
                                            borderColor: "#CCC",
                                            borderWidth: 1,
                                            shadow: false,
                                            itemStyle: {
                                                fontSize: '10px',

                                            }
                                        },
                                        tooltip: {
                                            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                                            shared: true,
                                        },
                                        plotOptions: {
                                            column: {
                                                stacking: "percent",
                                                dataLabels: {
                                                    enabled: true,
                                                    // format:'{point.percentage:.2f} %'
                                                    formatter: function () {
                                                        if (this.y != 0) {
                                                            return this.point.percentage.toFixed(1) + '%'
                                                        }
                                                    },
                                                }
                                            },
                                        },
                                        series: [{
                                                name: element.label[0],
                                                data: [element.Options[0]],
                                                // color: element.label[0] === "To Short" ? "#0099cc" : "#cc0000",
                                                color: "#cc0000"
                                            },
                                            {
                                                name: element.label[1],
                                                data: [element.Options[1]],
                                                color: "#ffd633",
                                            },
                                            {
                                                name: element.label[2],
                                                data: [element.Options[2]],
                                                // color: element.label[0] === "Duration is fine" ? "#cc0000" : "#0099cc" ,
                                                color: "#0099cc",

                                            },
                                        ],
                                    });
                                } else if (element.label &&
                                    element.label.length == 5) {

                                    Highcharts.chart("graph" + index, {
                                        chart: {
                                            type: "column",
                                        },
                                        title: {
                                            text: "Stacked column chart",
                                        },
                                        xAxis: {
                                            // categories: ["Practicals Testing"],
                                        },
                                        yAxis: {
                                            min: 0,
                                            stackLabels: {
                                                enabled: false,
                                                style: {
                                                    fontWeight: "bold",
                                                    color:
                                                        // theme
                                                        (Highcharts.defaultOptions.title.style &&
                                                            Highcharts.defaultOptions.title.style
                                                            .color) ||
                                                        "gray",
                                                },
                                            },

                                        },
                                        legend: {
                                            align: "center",
                                            x: -30,
                                            verticalAlign: "bottom",
                                            y: 15,
                                            floating: false,
                                            backgroundColor: Highcharts.defaultOptions.legend
                                                .backgroundColor || "white",
                                            borderColor: "#CCC",
                                            borderWidth: 1,
                                            shadow: false,
                                            itemStyle: {
                                                fontSize: '10px',
                                            }
                                        },
                                        tooltip: {
                                            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                            shared: true,
                                        },
                                        plotOptions: {
                                            column: {
                                                stacking: "percent",
                                                dataLabels: {
                                                    enabled: true,
                                                    formatter: function () {
                                                        if (this.y != 0) {
                                                            return this.point.percentage.toFixed(1) + '%'
                                                        }
                                                    },
                                                    // enabled:true,
                                                    // format:'{point.percentage:.2f} %',
                                                }
                                            },
                                        },
                                        series: [{
                                                name: element.label[0],
                                                data: [element.Options[0]],
                                                color: "#D1324E"

                                            },
                                            {
                                                name: element.label[1],
                                                data: [element.Options[1]],
                                                color: "#EF522F"

                                            },
                                            {
                                                name: element.label[2],
                                                data: [element.Options[2]],
                                                color: "#FEC447"
                                            },
                                            {
                                                name: element.label[3],
                                                data: [element.Options[3]],
                                                color: "#6AAA4A",

                                            },
                                            {
                                                name: element.label[4],
                                                data: [element.Options[4]],
                                                color: "#218FCE",

                                            }
                                        ]
                                    });
                                }

                            });
                            this.closeLoading();
                        }, 1000);
                        this.questionsArray = response.data;
                    }
                });
        },
        allStandardPostQuestions: function allStandardPostQuestions(tId) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/standardPostQuestionsNew/all/get/" +
                    tId
                )
                .then(response => {
                    if (response.data) {
                        setTimeout(() => {
                            response.data.forEach((element, index) => {

                                if (element.label && element.label.length == 2) {

                                    Highcharts.chart("graphp" + index, {
                                        chart: {
                                            plotBackgroundColor: null,
                                            plotBorderWidth: null,
                                            plotShadow: false,
                                            type: "pie",
                                        },
                                        title: {
                                            text: "Browser market shares in January, 2018",
                                        },
                                        tooltip: {
                                            pointFormat: "{series.name}: <b>{point.percentage:.2f}%</b>",
                                        },
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                cursor: "pointer",
                                                dataLabels: {
                                                    enabled: false,
                                                    formatter: function () {
                                                        if (this.y != 0) {
                                                            return this.point.percentage.toFixed(1) + '%'
                                                        }
                                                    },

                                                    //  format:'{point.percentage:.2f} %'
                                                },
                                                showInLegend: true,
                                            },
                                        },
                                        series: [{
                                            name: "Answer",
                                            colorByPoint: true,
                                            data: [{
                                                    name: element.label[0],
                                                    y: element.Options[0],
                                                    color: "#604a7b",
                                                },
                                                {
                                                    name: element.label[1],
                                                    y: element.Options[1],
                                                    color: "#558ed5",
                                                },
                                            ],
                                        }, ],
                                    });
                                } else if (
                                    element.label &&
                                    element.label.length == 4
                                ) {

                                    Highcharts.chart("graphp" + index, {
                                        chart: {
                                            type: "column",
                                        },
                                        title: {
                                            text: "Stacked column chart",
                                        },
                                        xAxis: {
                                            // categories: ["Practicals"],
                                        },
                                        yAxis: {
                                            min: 0,
                                            stackLabels: {
                                                enabled: false,
                                                style: {
                                                    fontWeight: "bold",
                                                    color:
                                                        // theme
                                                        (Highcharts.defaultOptions.title.style &&
                                                            Highcharts.defaultOptions.title.style
                                                            .color) ||
                                                        "gray",
                                                },
                                            },
                                        },
                                        legend: {
                                            align: "right",
                                            x: -30,
                                            verticalAlign: "bottom",
                                            y: 15,
                                            floating: false,
                                            backgroundColor: Highcharts.defaultOptions.legend
                                                .backgroundColor || "white",
                                            borderColor: "#CCC",
                                            borderWidth: 1,
                                            shadow: false,
                                            itemStyle: {
                                                fontSize: '12px',
                                            }
                                        },
                                        tooltip: {
                                            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                            shared: true,
                                        },
                                        plotOptions: {
                                            column: {
                                                stacking: "percent",
                                                dataLabels: {
                                                    enabled: true,

                                                    formatter: function () {
                                                        if (this.y != 0) {
                                                            return this.point.percentage.toFixed(1) + '%'
                                                        }
                                                    },

                                                    //  format:'{point.percentage:.2f} %'
                                                },
                                            },
                                        },
                                        series: [{
                                                name: element.label[0],
                                                data: [element.Options[0]],
                                                color: "#D1324E"
                                            },
                                            {
                                                name: element.label[1],
                                                data: [element.Options[1]],
                                                color: "#EF522F"
                                            },
                                            {
                                                name: element.label[2],
                                                data: [element.Options[2]],
                                                color: "#FEC447"
                                            },
                                            {
                                                name: element.label[3],
                                                data: [element.Options[3]],
                                                color: "#6AAA4A",

                                            }

                                        ],
                                    });
                                } else if (
                                    element.label &&
                                    element.label.length == 3
                                ) {

                                    Highcharts.chart("graphp" + index, {
                                        chart: {
                                            type: "column",
                                        },
                                        title: {
                                            text: "Stacked column chart",
                                        },
                                        xAxis: {
                                            // categories: ["Practicals"],
                                        },
                                        yAxis: {
                                            min: 0,
                                            stackLabels: {
                                                enabled: false,
                                                style: {
                                                    fontWeight: "bold",
                                                    color:
                                                        // theme
                                                        (Highcharts.defaultOptions.title.style &&
                                                            Highcharts.defaultOptions.title.style
                                                            .color) ||
                                                        "gray",
                                                },
                                            },
                                        },
                                        legend: {
                                            // align: "left",
                                            // x: -30,
                                            verticalAlign: "bottom",
                                            // y: 15,
                                            floating: false,
                                            backgroundColor: Highcharts.defaultOptions.legend
                                                .backgroundColor || "white",
                                            borderColor: "#CCC",
                                            borderWidth: 1,
                                            shadow: false,
                                            itemStyle: {
                                                fontSize: '7px',
                                                fontWeight: '1000',
                                            },
                                        },
                                        tooltip: {
                                            pointFormat: '<span class="inline" style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                            shared: true,
                                        },
                                        plotOptions: {

                                            column: {
                                                stacking: "percent",
                                                dataLabels: {
                                                    enabled: true,
                                                    formatter: function () {
                                                        if (this.y != 0) {
                                                            return this.point.percentage.toFixed(1) + '%'
                                                        }
                                                    },

                                                    //  format:'{point.percentage:.1f} %'
                                                },
                                            },
                                        },
                                        series: [{
                                                name: element.label[0],
                                                data: [element.Options[0]],
                                                // color: "#71da71",
                                                color: element.label[0] == "Too Short" ? "#D1324E" : "#71da71",

                                            },
                                            {
                                                name: element.label[1],
                                                data: [element.Options[1]],
                                                color: "#fec447",

                                            },
                                            {

                                                name: element.label[2],
                                                data: [element.Options[2]],
                                                //  color: "#D1324E",
                                                color: element.label[2] == "Duration is fine" ? "#71da71" : "#D1324E"

                                            }

                                        ]
                                    });
                                } else if (element.label &&
                                    element.label.length == 5) {

                                    Highcharts.chart("graphp" + index, {
                                        chart: {
                                            type: "column",
                                        },
                                        title: {
                                            text: "Stacked column chart",
                                        },
                                        xAxis: {
                                            // categories: ["Practicals"],
                                        },
                                        yAxis: {
                                            min: 0,
                                            stackLabels: {
                                                enabled: false,
                                                style: {
                                                    fontWeight: "bold",
                                                    color:
                                                        // theme
                                                        (Highcharts.defaultOptions.title.style &&
                                                            Highcharts.defaultOptions.title.style
                                                            .color) ||
                                                        "gray",
                                                },
                                            },
                                        },
                                        legend: {
                                            align: "right",
                                            x: -30,
                                            verticalAlign: "bottom",
                                            y: 15,
                                            floating: false,
                                            backgroundColor: Highcharts.defaultOptions.legend
                                                .backgroundColor || "white",
                                            borderColor: "#CCC",
                                            borderWidth: 1,
                                            shadow: false,
                                            itemStyle: {
                                                fontSize: '12px',
                                            }
                                        },
                                        tooltip: {
                                            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                            shared: true,
                                        },
                                        plotOptions: {
                                            column: {
                                                stacking: "percent",
                                                dataLabels: {
                                                    enabled: true,

                                                    formatter: function () {
                                                        if (this.y != 0) {
                                                            return this.point.percentage.toFixed(1) + '%'
                                                        }
                                                    },

                                                    //  format:'{point.percentage:.2f} %'
                                                },
                                            },
                                        },
                                        series: [{
                                                name: element.label[0],
                                                data: [element.Options[0]],
                                                color: "#D1324E"
                                            },
                                            {
                                                name: element.label[1],
                                                data: [element.Options[1]],
                                                color: "#EF522F"
                                            },
                                            {
                                                name: element.label[2],
                                                data: [element.Options[2]],
                                                color: "#FEC447"
                                            },
                                            {
                                                name: element.label[3],
                                                data: [element.Options[3]],
                                                color: "#6AAA4A",

                                            },
                                            {
                                                name: element.label[4],
                                                data: [element.Options[4]],
                                                color: "#218FCE",

                                            },
                                        ],
                                    });
                                }

                            })

                            this.closeLoading();
                        }, 1000);
                        this.questionsPArray = response.data;
                    }
                });
        },

        DepartmentData: function DepartmentData(tId) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/department/data/" +
                    tId

                )
                .then(response => {

                    this.closeLoading();
                    this.departmentReport = response.data;

                });
        },
        DesignationData: function DesignationData(tId) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/designation/data/" +
                    tId

                )
                .then(response => {

                    this.closeLoading();
                    this.designationReport = response.data;

                });
        },
        showTrainers: function showTrainers(tId) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/trainer/get/" +
                    tId
                )
                .then(response => {

                    this.closeLoading();
                    this.alltrainers = response.data;

                });
        },
        showMaleFemale: function showMaleFemale(tId) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/traineedetails/report/gender/get/" +
                    tId
                )
                .then(response => {

                    this.closeLoading();
                    this.maleCount = response.data?.male;
                    this.femaleCount = response.data?.female;
                    this.otherCount = response.data?.other;
                    this.totalCount = response.data?.genderCount;
                    this.genderChart();
                });
        },
        genderChart: function genderChart() {
            Highcharts.chart("pie-male-female", {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: "pie",
                },
                title: {
                    text: "Browser market shares at a specific website, 2014",
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.0f}%</b>",
                },
                accessibility: {
                    point: {
                        valueSuffix: "%",
                    },
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        // colors: pieColors,
                        dataLabels: {
                            enabled: true,
                            format: "<b>{point.name}</b><br>{point.percentage:.0f} %",
                            distance: -35,
                            filter: {
                                property: "percentage",
                                operator: ">",
                                value: 4,
                            },
                        },
                    },
                },
                series: [{
                    name: "Share",
                    data: [{
                            name: "Male",
                            y: this.maleCount,
                            color: "#2084c7"
                        },
                        {
                            name: "Female",
                            y: this.femaleCount,
                            color: "#ff6882"
                        },
                        {
                            name: "Other",
                            y: this.otherCount,
                            color: "#7FD1B9"
                        }
                    ],
                }, ],
            });
        },
        openLoading() {
            this.$vs.loading({
                type: "material",
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        formSubmitted() {
            alert("Form submitted!");
        },
        next: function () {
            if (this.currentQ + 1 < this.questions.length) {
                this.currentQ++;
            }
        },
        PrintTrainingDetails: function () {
            window.print();
        },

        openWindow1() {
            const basepath = this.basepath;
            const trainingCode = this.trainingCode;
            const token = localStorage.getItem('token');
            const url = `https://graphs.tmisodc.org/?trainingCode=${trainingCode}&token=${token}&basepath=${basepath}`;
            window.open(url, '_blank');
        },

        goToPrintEvent() {
            const role = localStorage.getItem('isPermission');

            if (role === 'admin') {
                this.$router.push({
                    path: '/dashboard/Admin/PrintReportAdmin',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            } else if (role === 'program_officer') {
                this.$router.push({
                    path: '/dashboard/programOfficer/PrintReportPO',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            } else {
                // Optional: handle unknown roles
                alert('You do not have permission to view this report.');
            }
        },

        printReport() {
            const BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH
            const pdfLink = `${BASEPATHDYNAMIC}/uploads/trainingsReports/${this.trainingCode}.pdf`;
            window.open(pdfLink, '_blank');
        },
        openIndividual() {
            const permission = localStorage.getItem('isPermission');
            let basePath = '';

            switch (permission) {
                case 'admin':
                    basePath = '/dashboard/admin/individual_analysis_report';
                    break;
                case 'program_officer':
                    basePath = '/dashboard/programOfficer/individual_analysis_report';
                    break;
                case 'advisor':
                    basePath = '/dashboard/advisor/individual_analysis_report';
                    break;
                default:
                    console.error('Unknown permission type');
                    return;
            }

            this.$router.push({
                path: basePath,
                query: {
                    trainingId: this.trainingCode
                }
            });
        }
    },
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

#page_one_count {
    display: none;
}

#page_two_count {
    display: none;
}

li {
    list-style-type: none !important;
}

.f-500 {
    font-weight: 500;
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
}

.save-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #f9f9f9;
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* table changes */
.table th,
.table td {
    padding: 0.25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

.vs-popup--background {
    opacity: 0.3 !important;
}

.con-img-upload .img-upload {
    width: 150px !important;
}

.cont-bdr {
    display: none;
}

.cont-bdr {
    border-top: 1px solid #ebe9e9;
    border-right: 1px solid #ebe9e9;
}

.col-bdr-bottom {
    border-bottom: 0.5px solid #ebe9e9;
    border-left: 0.5px solid #ebe9e9;
}

.mt-10 {
    margin-top: 78px;
}

.line-bordered {
    border-top: 2px solid #6c757d;
    border-bottom: 2px solid #6c757d;
    border-left: 1px solid #6c757d;
    border-right: 1px solid #6c757d;
}

.text-css h4 {
    color: #009ad2;
    text-transform: capitalize;
}

.text-css h5 {
    color: #6c757d;
    text-transform: capitalize;
}

.text-css h6 {
    color: #6c757d;
    text-transform: capitalize;
}

.text-css p {
    color: #6c757d;
    font-size: 18px;
    font-weight: 700;
    text-transform: capitalize;
}

.text-blue {
    color: #00a4ea;
}

.btn-report {
    background-color: #6488d2 !important;
    border-radius: 0px !important;
    padding: 3px 30px !important;
}

.highcharts-credits {
    display: none !important;
}

.highcharts-title {
    display: none !important;
}

.div#highcharts-4bv8m9d-0 {
    z-index: -5 !important;
}

@media print {

    #page-content-wrapper {
        overflow: visible !important;
        height: auto !important;
    }

    .print_logo {
        display: block !important;
        text-align: justify;
    }

    /* Training title */
    .print-trainin-title {
        font-size: 20px;
    }

    .print-actual {
        height: 400px;
        width: 100px;
        margin-bottom: 500px;

    }

    .print-actual-graph {
        height: 170px;
        width: 100px;
    }

    .print-actual-size {
        width: 100%;
        height: 300px;
    }

    .print_screen2 {
        margin-top: 0px;
    }

    .print_screen {
        margin-top: 35px;
    }

    .print-margin {
        margin-bottom: 100px;

    }

    .average_actual {
        margin-top: 0px;
    }

    .btn-report {
        display: none;
    }

    .print-media {
        display: none;
    }

    .col-md-4 {
        flex: 1;
        max-width: 50%;
    }

    .col-md-3 {
        flex: 1;
        max-width: 33.33%;
    }

    .print-title {
        font-size: 15px;
    }

    .print-training-title {
        display: none;
    }

    footer {
        position: fixed;
        bottom: 0;
    }

    .chart-container {
        page-break-before: always;
    }

}
</style>
